export default __webpack_public_path__ + "static/award-3-ec52ca80045f8df5b9a955cce60b7bfb.png";